module.exports = __webpack_public_path__ + "img/1f617.fb73e69.svg";